import {PolyScene} from '../../@polygonjs/polygonjs/src/engine/scene/PolyScene';
import {SceneJsonExporter} from '../../@polygonjs/polygonjs/src/engine/io/json/export/Scene';
import engine_config from '../../@polygonjs/polygonjs/package.json';
import editor_config from '../../package.json';
interface PackageConfig {
	version: string;
	name: string;
}
const ENGINE_VERSION = (engine_config as PackageConfig).version;
const EDITOR_VERSION = (editor_config as PackageConfig).version;

export function versions() {
	return {
		polygonjs: ENGINE_VERSION,
		editor: EDITOR_VERSION,
	};
}

export function sceneDataWithVersion(scene: PolyScene) {
	const exporter = new SceneJsonExporter(scene);
	const sceneData = exporter.data({polygonjs: ENGINE_VERSION});
	return sceneData;
}
